module.exports = __webpack_public_path__ + "static/img/139.ad74eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/139.png
// module id = JMmW
// module chunks = 0